import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import MobileRepairBookingPage from './Mobile-Repair-Booking-Page';
import ModelPage from './pages/ModelPage';
import ServicePage from './pages/ServicePage';
import CartPage from './pages/CartPage';
import AddressPage from './pages/AddressPage';
import PaymentStatusPage from './pages/PaymentStatusPage';
import LoginPage from './pages/LoginPage';
import OrderSummaryPage from './pages/OrderSummaryPage';
import OrdersPage from './pages/OrdersPage';
import { CartProvider } from './context/CartContext';
import CartFooter from './components/CartFooter';
import AboutUsPage from './pages/AboutUsPage';
import FAQPage from './pages/FAQPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import RefundsCancellationsPage from './pages/RefundsCancellationsPage';
import AndheriPage from './pages/AndheriPage';
import BandraPage from './pages/BandraPage';
import BorivaliPage from './pages/BorivaliPage';
import DadarPage from './pages/DadarPage';
import LowerParelPage from './pages/LowerParelPage';
import VileParlePage from './pages/VileParlePage';
import GoregaonPage from './pages/GoregaonPage';
import MaladPage from './pages/MaladPage';
import GhatkoparPage from './pages/GhatkoparPage';
import KurlaPage from './pages/KurlaPage';
import ThanePage from './pages/ThanePage';
import ChemburPage from './pages/ChemburPage';
import NaviMumbaiPage from './pages/NaviMumbaiPage';
import BKCPage from './pages/BKCPage';
import PowaiPage from './pages/PowaiPage';
import WorliPage from './pages/WorliPage';
import JuhuPage from './pages/JuhuPage';
import ColabaPage from './pages/ColabaPage';
import IPhone13BatteryPage from './pages/blogs/iPhone13BatteryPage';
import IPhone14BatteryPage from './pages/blogs/iPhone14BatteryPage';
import ScreenReplacementPage from './pages/ScreenReplacementPage';
import BatteryReplacementPage from './pages/BatteryReplacementPage';
import ChargingPortRepairPage from './pages/ChargingPortRepairPage';
import SpeakerMicRepairPage from './pages/SpeakerMicRepairPage';
import SoftwareRepairPage from './pages/SoftwareRepairPage';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<MobileRepairBookingPage />} />
            <Route path="brand/:brandId" element={<ModelPage />} />
            <Route path="services/:modelId" element={<ServicePage />} />
            <Route path="services/:modelId/*" element={<ServicePage />} />
          </Route>
          <Route path="/cart" element={<CartPage />} />
          <Route path="/address" element={<AddressPage />} />
          <Route path="/payment-status/:orderId" element={<PaymentStatusPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/order-summary/:orderId" element={<OrderSummaryPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/refunds-cancellations" element={<RefundsCancellationsPage />} />
          {/* Western Line */}
          <Route path="/mobile-repair-lower-parel" element={<LowerParelPage />} />
          <Route path="/mobile-repair-dadar" element={<DadarPage />} />
          <Route path="/mobile-repair-bandra" element={<BandraPage />} />
          <Route path="/mobile-repair-vile-parle" element={<VileParlePage />} />
          <Route path="/mobile-repair-andheri" element={<AndheriPage />} />
          <Route path="/mobile-repair-goregaon" element={<GoregaonPage />} />
          <Route path="/mobile-repair-malad" element={<MaladPage />} />
          <Route path="/mobile-repair-borivali" element={<BorivaliPage />} />
          {/* Central Line */}
          <Route path="/mobile-repair-ghatkopar" element={<GhatkoparPage />} />
          <Route path="/mobile-repair-kurla" element={<KurlaPage />} />
          <Route path="/mobile-repair-thane" element={<ThanePage />} />
          {/* Harbour Line */}
          <Route path="/mobile-repair-chembur" element={<ChemburPage />} />
          <Route path="/mobile-repair-navi-mumbai" element={<NaviMumbaiPage />} />
          {/* Premium Areas */}
          <Route path="/mobile-repair-bkc-bandra" element={<BKCPage />} />
          <Route path="/mobile-repair-powai" element={<PowaiPage />} />
          <Route path="/mobile-repair-worli" element={<WorliPage />} />
          <Route path="/mobile-repair-juhu" element={<JuhuPage />} />
          <Route path="/mobile-repair-colaba-south-mumbai" element={<ColabaPage />} />
          {/* Battery Repair Blogs */}
          <Route path="/iphone-13-battery-replacement" element={<IPhone13BatteryPage />} />
          <Route path="/iphone-14-battery-replacement" element={<IPhone14BatteryPage />} />
          {/* Service Pages */}
          <Route path="/screen-replacement" element={<ScreenReplacementPage />} />
          <Route path="/battery-replacement" element={<BatteryReplacementPage />} />
          <Route path="/charging-port-repair" element={<ChargingPortRepairPage />} />
          <Route path="/speaker-mic-repair" element={<SpeakerMicRepairPage />} />
          <Route path="/software-repair" element={<SoftwareRepairPage />} />
        </Routes>
        <CartFooter />
      </Router>
    </CartProvider>
  );
};

export default App; 